angular.module('app.controllers.non-paginated-forms.landlord-agreement', [])

    .controller("LandlordAgreementController", function ($scope, $window, $http, appConstants) {
        $scope.steps = ['applicants', 'billing', 'propertyManagement', 'signature'];
        $scope.stepTitles = ['Owner', 'Billing', 'Property', 'Signature'];
        $scope.step = $scope.steps[0];
        $scope.patterns = appConstants.patterns;
        $scope.aversion = appConstants.version;
        $scope.numAccounts = 1;
        $scope.form_processed = "";
        $scope.caprequired = appConstants.captchaRequired; // localhost = false otherwise true
        $scope.today = new Date();
        $scope.form_name = "Landlord Agreement";
        $scope.uploadFile = "";
        $scope.uploadFileExists = false;
        $scope.uploadFileError = false;
        $scope.userUploadErrors="";
      //  $scope.coapplicant = $scope.coapplicantFN + " " + $scope.coapplicantLN;
        $scope.form_info = [
            "Please complete all information on this Agreement and click the submit button."
        ];
        $scope.success_response = [
            ""
        ];
        $scope.success_detail = [
            "Your Landlord Agreement was submitted successfully."
        ];
        $scope.accountList = [
            { addr: '', apt: '', acct: '' }
        ];

        $scope.formsInvalid = function() {
            var invalid = $scope.landlordAgreementForm.$invalid;
            for (var i = 0; i < $scope.steps.length; i++) {
                invalid = invalid || $scope[$scope.steps[i] + 'Form'].$invalid;
            }
            return invalid;
        };

        $scope.setFormsPristine = function() {
            $scope.landlordAgreementForm.$setPristine();
            for (var i = 0; i < $scope.steps.length; i++) {
                $scope[$scope.steps[i] + 'Form'].$setPristine();
            }
        };

        $scope.haveAnyCoapplicantData = function() {
            return $scope.applicantsForm.coapplicantFN.$viewValue || $scope.applicantsForm.coapplicantLN.$viewValue || 
                   $scope.applicantsForm.coapplicantphonenum.$viewValue || $scope.applicantsForm.coapplicantemail.$viewValue || 
                   $scope.applicantsForm.coapplicantdob.$viewValue || $scope.applicantsForm.coapplicantlast4OfSsn.$viewValue;
        };

        $scope.getStateClass = function(field) {
            if (field.$touched || field.$dirty) {
                return field.$valid ? 'has-success' : 'has-error';
            }
            return null;
        };

        $scope.move = function(step) {
            $scope.step = step;
        };

        $scope.previousStep = function() {
            var index = $scope.steps.indexOf($scope.step) - 1;
            if (index < $scope.steps.length) {
                return $scope.steps[index];
            }
            return null;
        };

        $scope.nextStep = function() {      
            var index = $scope.steps.indexOf($scope.step) + 1;
            if (index < $scope.steps.length) {
                return $scope.steps[index];
            }            
            return null;
        };

        $scope.canMove = function(step) {
            if (step) {
                var targetStepIndex = $scope.steps.indexOf(step);
                for (var i = 0; i < targetStepIndex; i++) {
                    var form = $scope.steps[i] + 'Form';
                    if ($scope[form].$invalid) {
                        return false;
                    }
                }
                return true;
            }
            return false;
        };

        $scope.addAccount = function () {
            $scope.accountList.push({ addr: '', apt: '', acct: '' });
            $scope.numAccounts++;
        };
        $scope.removeAccount = function (idx) {
            $scope.accountList.splice(idx, 1);
            $scope.numAccounts--;
        };

        $scope.filename = "";
        $scope.setupFile = function (input) {
            var element = angular.element(input);
            var field = $scope.signatureForm.userUpload;
            var accepts = element.context.accept.split(',');
            var filename = element.context.value;
            
            if (filename) {
                var dotIndex = filename.lastIndexOf('.');
                var extension = '';
                if (dotIndex > -1) {
                    extension = filename.substr(dotIndex).toLowerCase();
                }
                if (accepts.indexOf(extension) == -1) {
                    field.$setValidity('extension', false);
                    $scope.filename = undefined;
                } else {
                    $scope.filename = filename;
                    field.$setValidity('extension', true);
                    field.$setValidity('required', true);
                }
            } else {
                $scope.filename = undefined;
                field.$setValidity('required', ($scope.signatureForm.acctinfo.$modelValue && $scope.signatureForm.acctinfo.$valid));
            }
            
            $scope.$digest();
        };

        $scope.resetForm = function () {
            $scope.firstname = "";
            $scope.lastname = "";
            $scope.email = "";
            $scope.ssn = "";
            $scope.dob = "";
            $scope.phonenum = "";
            $scope.coapplicantFN = "";
            $scope.coapplicantLN = "";
            $scope.coapplicantphonenum = "";
            $scope.coapplicantemail = "";
            $scope.coapplicantdob = "";
            $scope.coapplicantlast4OfSsn = "";
            $scope.address = "";
            $scope.city = "";
            $scope.state = "";
            $scope.zipcode = "";
            $scope.incareof = "";
            $scope.managersname = "";
            $scope.last4OfManagerSsn = "";
            $scope.managerphonenum = "";
            $scope.acctinfo = "";
            $scope.sig = "";
            $scope.accountlist = [{ addr: '', apt: '', acct: '' }];
            $scope.numAccounts = 0;
            $('html,body').scrollTop(0);
        };
        $scope.resetForm();

        $window.setCapRequired = function (value) {
            $scope.caprequired = value;
            $scope.$digest();
        };

        $scope.submit = function () {
            if ($scope.form_processed === "") {
                $scope.form_processed = "Processing . . .";
                var fd = new FormData();
                fd.append("firstname", $scope.firstname);
                fd.append("lastname", $scope.lastname);
                fd.append("email", $scope.email);
                fd.append("ssn", $scope.ssn);
                //fd.append("dob", $scope.dob.getMonth() + '/' + $scope.dob.getDate() + '/' + $scope.dob.getFullYear());
                fd.append("dob", $scope.dob);
                fd.append("phonenum", $scope.phonenum);
                fd.append("coapplicant", $scope.coapplicantFN + " " + $scope.coapplicantLN);
                fd.append("coapplicantphonenum", $scope.coapplicantphonenum);
                fd.append("coapplicantemail", $scope.coapplicantemail);
                if ($scope.coapplicantdob) {
                    fd.append("coapplicantdob", $scope.coapplicantdob);
                    //fd.append("coapplicantdob", $scope.coapplicantdob.getMonth() + '/' + $scope.coapplicantdob.getDate() + '/' + $scope.coapplicantdob.getFullYear());
                }
                fd.append("coapplicantlast4OfSsn", $scope.coapplicantlast4OfSsn);
                fd.append("address", $scope.address.replace(/#/g, ":"));
                fd.append("city", $scope.city);
                fd.append("state", $scope.state);
                fd.append("zipcode", $scope.zipcode);
                fd.append("incareof", $scope.incareof);
                fd.append("managersname", $scope.managersname);
                fd.append("last4OfManagerSsn", $scope.last4OfManagerSsn);
                fd.append("managerphonenum", $scope.managerphonenum);
                fd.append("acctinfo", $scope.acctinfo);
                fd.append("sig", $scope.sig);
                fd.append("gRecaptchaResponse", grecaptcha.getResponse());
                fd.append("file", jQuery("#userUpload").get(0).files[0]);

                $scope.numAccounts = $scope.accountList.length;
                for (var i = 0; i < $scope.numAccounts; i++) {
                    fd.append("addresses", $scope.accountList[i].addr);
                    fd.append("apts", $scope.accountList[i].apt);
                    fd.append("accts", $scope.accountList[i].acct);
                }

                $http.post('/swgasws/resources/form/landlordagreement/add', fd, {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                })
                .success(function (data) {
                    console.log('success', data);

                    switch (data.status) {
                        case 'success':
                            document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-good'>" + data.message + "</span><span class='form-sub-normal'> Thank you for your interest in the Landlord Program. Please allow two weeks for processing.</span></p>";
                            break;
                        case 'badrequest':
                            document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>" + data.message +
                                " Please try again later.  The Webmaster has been notified of the following submission problem(s): <br /> " + data.sysmessage + "</span></p>";
                            break;
                        default:  // all other errors
                            document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>" + data.message + " The Webmaster has been notified of this submission problem.</span></p>";

                    }  // end switch         

                    $scope.isDisabled = true;
                    $scope.resetForm();
                    $scope.setFormsPristine();
                })
                .error(function (response) {
                    console.log('error', response);
                    document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>Your Landlord Agreement inquiry has NOT been sent due to maintenance.  We apologize for the inconvenience at this time. Please try again later.</span></p>";
                    $scope.resetForm();
                    $scope.setFormsPristine();
                });
            }
        };
    });